import React, { useState } from 'react'
import {
  Dialog, TextField, Grid, DialogActions, DialogContent, Button,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../reducers/form';
import 'moment/locale/ru';
import moment from 'moment'
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { updWorkGant } from '../../api/form-gant.api'
import { fetchDispath } from '../../functions/fetch'
import { addDays } from './utils/dateHelpers';


function formSelector(formName, field) {
  return state => state.form?.[formName]?.values[field]
}

export default function GantDialogDate({ formName, formDialogDate, idProject, setLoad }) {
  const dispatch = useDispatch()
  const [countDate, setCountDate] = useState(1)
  const open = useSelector(formSelector(formDialogDate, 'open')) || false
  const processUpdate = (countDate) => (dispatch, getState) => {
    const state = getState()
    const byId = state.form?.[formName]?.values.byId
    const gant = state.gant
    const obj = state.form?.[formDialogDate]?.values.obj
    const moveDispatchMulti = (arr) => dispatch(actions.formObjChangeObjMulti(arr, { field: 'byId', name: formName }))
    const moveArr = []
    const getAllChild = (arr) => {
      for (let i = 0; i < arr.length; i++) {
        const id = arr[i]
        const objChild = byId[id]
        if (objChild.typeGant === 'parent' && objChild.child && objChild.child.length > 0) {
          getAllChild(objChild.child)
        }
        else {
          moveArr.push(objChild.idAPI)
        }
      }
    }
    const getAllMoveChildParent = (arr) => {
      const { adjList } = gant
      if (arr.length === 0) return []
      const arrRes = []
      const visited = []
      const notVisited = arr
      while (notVisited.length > 0) {
        const find = notVisited.pop()
        if (!visited.includes(find)) {
          visited.push(find)
          if (adjList[find]) {
            notVisited.push(...adjList[find].map(e => e.to))
          }
        }
      }
      visited.forEach(id => {
        const objChild = byId['id' + id]
        if (objChild.typeGant !== 'milestone' && objChild.typeGant !== 'link') {
          const newEnd = addDays(objChild.start, countDate - 1)
          arrRes.push({
            idAPI: id,
            body: { end: newEnd }
          })
        }
      })
      return arrRes
    }
    getAllChild(obj.child)
    const arrBody = getAllMoveChildParent(moveArr);
    moveDispatchMulti(arrBody.map(e => ({ id: 'id' + e.idAPI, data: { end: e.body.end, duration: countDate } })))
    arrBody.forEach(e => {
      dispatch(fetchDispath({
        param: {
          id: e.idAPI
        },
        body: e.body,
        request: updWorkGant(idProject),
      })).then(res => { }).catch(err => { console.log(err) })
    })
  }
  const handleOk = () => {
    dispatch(processUpdate(countDate));
    setCountDate(1)
    setLoad(true)
    onClose()
  }
  const onClose = () => {
    dispatch(actions.formChange(false, { field: 'open', name: formDialogDate }))
  }
  return <div>
    <Dialog
      open={open}
      maxWidth='sm'
      keepMounted
      fullWidth
      scroll="paper"
      onClose={onClose}
    >
      <DialogContent >
        <TextField
          autoFocus
          required
          margin="dense"
          id="name"
          name="countDate"
          label="Количество"
          type="number"
          fullWidth
          variant="standard"
          value={countDate}
          onChange={(e) => setCountDate(Number(e.target.value))}
          inputProps={{
            min: 1,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Grid container direction='row' alignItems="flex-end">
          <Grid item xs={3}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<CheckIcon />}
              onClick={handleOk}
              size='small'
            >Сохранить
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<CloseIcon />}
              onClick={onClose}
              size='small'
            >Отменить
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  </div>
}